import type { OrderItem, Product } from "@jti/magento";

export const checkIfSubscriptionOrder = (items: Product[] | OrderItem[] = []): boolean => {
  return items.some((item) => item.subscription === 1) ?? false;
};
